export enum PlanId {
  CurrentPlan,
  NewPlan,
}

export interface PurchaseCardConfig {
  title: string;
  productId: number;
  currentPlan: PlanConfig;
  newPlan: PlanConfig;
  buyButton: {
    title: string;
    loading: boolean;
    buyEventHandlerFn: () => void;
  };
  autorenewal?: boolean;
  priceConfig?: {
    totalPrice: number;
    currency: string;
    loading: boolean;
  };
  discountText?: string;
  renewalNotAvailableYetText?: string;
  maxSeats?: number;
  maxSeatsAlreadyExceeded?: boolean;
  showBuyNewLicense?: boolean;
}

export interface PlanConfig {
  title: string;
  seats: number;
  availableUntil: Date;
  serverSeats?: number;
  years?: number;
  inputChanges?: {
    seatChange?: boolean;
    serverChange?: boolean;
    dateChange?: boolean;
  };
}
